import { Component, OnInit, Inject } from '@angular/core';
import { CustomerNotesService } from '../customer-notes.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';
import { CustomerNotesViewModel } from '../customer-notes.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SelectionLists, Customer } from '../../../entities';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-new-customer-notes',
  templateUrl: './new-customer-notes.component.html',
  styleUrls: ['./new-customer-notes.component.scss']
})
export class NewCustomerNotesComponent implements OnInit {
  saving= false;
  newModel = new CustomerNotesViewModel();

  selectionLists = new SelectionLists();
  selectedCustomer = new Customer();
  newCustomerNotesForm: FormGroup;
  customerSelectionControl: FormControl;
  notesControl: FormControl;
  editing = false;

  constructor( private _loading: LoadingService,
    public dialogRef: MatDialogRef<NewCustomerNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _customerNoteService: CustomerNotesService) { }

  ngOnInit() {

    if (this.data.listOfCustomers !== undefined) {
      this.selectionLists.customerList = this.data.listOfCustomers;
      this.selectedCustomer = this.data.selectedCustomer;
    }else if (this.data.editCustomerNotes) {
      this.editing = true;
      const editModel = this.data.editCustomerNotes;
      this.newModel.AddressToCustomerId = editModel.AddressToCustomerId;
      this.newModel.AddressToCustomerName = editModel.AddressToCustomerName;
      this.newModel.CreatedDated = editModel.CreatedDated;
      this.newModel.CreatedUserId = editModel.CreatedUserId;
      this.newModel.CreatedUserName  = editModel.CreatedUserName;
      this.newModel.Id = editModel.Id;
      this.newModel.Note = editModel.Note;
    }


    this.customerSelectionControl = new FormControl(this.newModel.AddressToCustomerId, [
      Validators.required,
    ]);
    this.notesControl  =  new FormControl(this.newModel.Note, [
      Validators.required,
    ]);
    this.newCustomerNotesForm = new FormGroup({
      customerSelectionControl: this.customerSelectionControl,
      notesControl : this.notesControl,
    });
  }

  customerChanged(event) {
    this.selectedCustomer = event.value;
    if (! this.selectedCustomer ) {
      return;
    }
    this.newModel.AddressToCustomerId = this.selectedCustomer.Id;
  }


  SaveCustomerNote() {
    this._loading.startLoading();
    this.saving = true;
    this.newModel.AddressToCustomerId = this.selectedCustomer.Id;
    this._customerNoteService.SaveCustomerNote(this.newModel).subscribe(r => {
      this._loading.finishedLoading();
      this.saving = false;
      if (r.m_Item1) {
        this._notification.success('Sucessfully saved customer notes');
        this.dialogRef.close(r.m_Item2);
      }  else {
        this._notification.success('Failed to save customer notes');
      }
    });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
}
